import {format} from "date-fns";

// #############################################
// CONST AND INITIAL STATE
// #############################################
export const statusArr = [
  {label: "Aberto", value: "OPEN"},
  {label: "Encerrado", value: "CLOSED"},
]
export const initialJanitorialForm = {
  user_start: "",
  date_start: null,
  status: "OPEN",
  requester: "",
  reason: "",
  user_end: "",
  date_end: "",
  janitorial_file: null,
  janitorial_file_attach: "",
  description: "",
  place: "",
  type_place: "",
  street: "",
  number: "",
  neighborhood: "",
  crossroads: "",
  reference_point: "",
  city: "",
  district: "",
  latitude: "",
  longitude: ""
}

// #############################################
// FUNCTIONS
// #############################################
export function checkInstalledItems(equipments) {
  const itensQuantity = equipments
    .filter(equipment => equipment.action === "INSTALLATION")
    .reduce((acc, curr) => {
      acc[curr.item] = (acc[curr.item] || 0) + curr.quantity;
      return acc;
    }, {});

  const itensRemoved = equipments
    .filter(equipment => equipment.action !== "INSTALLATION")
    .reduce((acc, curr) => {
      acc[curr.item] = (acc[curr.item] || 0) + curr.quantity;
      return acc;
    }, {});

  return Object.keys(itensQuantity).some(item => {
    const installed = itensQuantity[item] || 0;
    const removed = itensRemoved[item] || 0;
    return installed > removed;
  });
}
export function buildJanitorialObj(janitorial){
  const cityRaw = janitorial.city ?? "";

  const [cityName, stateName] = cityRaw.split(" - ");
  const extractedDistrict = stateName ? stateName.trim() : "";

  return {
    user_start: Number(janitorial.user_start),
    date_start: janitorial.date_start ? new Date(janitorial.date_start) : "",
    status: janitorial.status ?? "",
    requester: janitorial.requester ?? "",
    reason: janitorial.reason ?? "",
    user_end: Number(janitorial.user_end),
    date_end: janitorial.date_end ? new Date(janitorial.date_end) : "",
    janitorial_file: janitorial.janitorial_file,
    janitorial_file_attach: janitorial.janitorial_file,
    description: janitorial.description ?? "",
    place: Number(janitorial.place),
    type_place: janitorial.type_place ?? "",
    street: janitorial.street ?? "",
    number: janitorial.number ?? "",
    neighborhood: janitorial.neighborhood ?? "",
    crossroads: janitorial.crossroads ?? "",
    reference_point: janitorial.reference_point ?? "",
    city: cityRaw,
    district: extractedDistrict,
    latitude: janitorial.latitude ?? "",
    longitude: janitorial.longitude ?? "",
  }
}

export function buildJanitorialFormData(removedItens, form, equipments, file){
  const formData = new FormData();

  formData.append("user_start", form.user_start ?? "");
  formData.append(
    "date_start",
    form.date_start ? format(form.date_start, "dd/MM/yyyy HH:mm") : ""
  );
  formData.append("status", form.status ?? "");
  formData.append("requester", form.requester ?? "");
  formData.append("reason", form.reason ?? "");
  formData.append("user_end", form.user_end ?? "");
  formData.append(
    "date_end",
    form.date_end ? format(form.date_end, "dd/MM/yyyy HH:mm") : ""
  );
  formData.append("description", form.description ?? "");
  formData.append("place", form.place ?? "");
  formData.append("type_place", form.type_place ?? "");
  formData.append("street", form.street ?? "");
  formData.append("number", form.number ?? "");
  formData.append("neighborhood", form.neighborhood ?? "");
  formData.append("crossroads", form.crossroads ?? "");
  formData.append("reference_point", form.reference_point ?? "");
  formData.append("city", form.city ?? "");
  formData.append("district", form.district ?? "");
  formData.append("latitude", form.latitude ?? "");
  formData.append("longitude", form.longitude ?? "");
  formData.append(
    "equipments",
    JSON.stringify(
      [...equipments, ...removedItens].map(({ tempId, date, ...rest }) => ({
        ...rest,
        date: format(date, "dd/MM/yyyy HH:mm")
      }))
    )
  );
  formData.append("janitorial_file_attach", form.janitorial_file_attach ?? "");

  if (file instanceof File) {
    formData.append("janitorial_file", file);
  }

  return formData;
}

export function validateEquipmentsFields(equipments) {
  const fieldLabels = {
    item: "Item",
    action: "Ação",
    user: "Usuário",
    date: "Data/hora",
    quantity: "Quantidade"
  };

  for (let i = 0; i < equipments.length; i++) {
    const equipment = equipments[i];

    for (const key in fieldLabels) {
      if (
        equipment[key] === null ||
        equipment[key] === undefined ||
        equipment[key] === ""
      ) {
        return `O campo "${fieldLabels[key]}" é obrigatório.`;
      }
    }
  }

  return null;
}